const aboutUs = {
  title: () => 'About italist | How italist does it better?',
  description: () =>
    'Shop at italist 1,000 luxury international fashion brands from exclusively the best Italian stores. The same high-quality products at a lower price'
};

export default aboutUs;
